import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEntitled } from '../lib/tools';
import { Button } from './ui';

// Wrap a tool page's content. If the group doesn't own the tool, show a locked
// upsell instead — no entitlement, no access (brief Task 2). The 6-bubble home is
// the main sell surface; this is the backstop for direct navigation.
export function ToolGate({ tool, title, children }: { tool: string; title: string; children: ReactNode }) {
  const entitled = useEntitled(tool);
  const navigate = useNavigate();
  if (entitled) return <>{children}</>;
  return (
    <div className="mx-auto max-w-md py-16 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border border-line bg-surface-2 text-2xl">🔒</div>
      <h1 className="h-display text-3xl text-soft">{title} is locked</h1>
      <p className="mx-auto mt-2 max-w-sm text-sm text-muted">
        Unlock {title} to start using it. Your CRM and everything you've already set up stays exactly as it is.
      </p>
      <div className="mt-6">
        <Button onClick={() => navigate(`/pricing?tool=${tool}`)}>Unlock {title}</Button>
      </div>
    </div>
  );
}
